export const GAME_READY = 'GAME_READY'
export const GAME_PLAYING = 'GAME_PLAYING'
export const GAME_PAUSED = 'GAME_PAUSED'
export const GAME_OVER = 'GAME_OVER'

export const MOVE_SNAKE = 'MOVE_SNAKE'
export const CHANGE_SNAKE_DIRECTION = 'CHANGE_SNAKE_DIRECTION'
export const EAT_FOOD = 'EAT_FOOD'
export const LEVEL_UP = 'LEVEL_UP'

export const AUTH_SUCCESSFUL = 'AUTH_SUCCESSFUL'
export const AUTH_FAILED = 'AUTH_FAILED'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'

export const LB_OPEN = 'LB_OPEN'
export const LB_LOADED = 'LB_LOADED'
export const LB_CLOSE = 'LB_CLOSE'
